import * as React from 'react';
import { NotLoggedInActionStatus } from 'client/respondent/core/types';
import { SignupContainer } from 'client/respondent/account/containers/access/signup';
import * as RespondentContext from 'client/respondent/core/reducers/context';
import { RespondentActions } from 'client/respondent/core/reducers/actions';
import { useRedirect } from 'client/shared/hooks';

export const SignupPage: React.FC = () => {
  const state = RespondentContext.useRespondentState();
  const dispatch = RespondentContext.useRespondentDispatch();
  const redirect = useRedirect();

  return (
    <SignupContainer
      converted={({ conversionType }) => {
        dispatch(RespondentActions.registrationSuccessful(conversionType));
        const redirectLink =
          state.preLoginAction &&
          state.preLoginAction.status !== NotLoggedInActionStatus.ACTION_COMPLETE
            ? state.preLoginAction.redirectLink
            : null;
        if (redirectLink) {
          redirect(redirectLink, {
            push: true,
          });
        }
      }}
    />
  );
};
